import { useState } from 'react';

type useNumberPagesType = {
  indexOfFirstPost: number;
  indexOfLastPost: number;
  setCurrentPage: (currentPage: number) => void;
  currentPage: number;
  MAX_COUNT_ELEMENTS: number;
};

const useNumberPages = (count = 20): useNumberPagesType => {
  const [currentPage, setCurrentPage] = useState(1);

  const MAX_COUNT_ELEMENTS = count;

  const indexOfLastPost = currentPage * MAX_COUNT_ELEMENTS;
  const indexOfFirstPost = indexOfLastPost - MAX_COUNT_ELEMENTS;

  return {
    indexOfFirstPost,
    indexOfLastPost,
    setCurrentPage,
    currentPage,
    MAX_COUNT_ELEMENTS,
  };
};

export { useNumberPages };
